const faqItems = [
  {
    q: '51黑料网是什么？与其他平台有何不同？',
    a: '51黑料网是国内领先的娱乐资讯聚合平台，区别于传统社交媒体和新闻客户端，我们专注于娱乐领域的深度内容筛选与聚合。51黑料网站首页每日实时更新，覆盖明星动态、影视综艺、音乐演出、体育赛事等多个垂直领域，通过专业团队审核与智能算法结合，确保资讯质量。51黑料网页版无需下载即可使用，访问便捷。',
  },
  {
    q: '如何通过51黑料官网入口访问平台？',
    a: '访问51黑料官网非常简单：直接在浏览器中输入51黑料官网地址即可进入51黑料网站首页。无需注册账号、无需下载App、无需任何复杂操作。你也可以将51黑料网页版添加到浏览器书签，实现一键直达。同时建议关注51黑料的社交媒体账号获取最新入口信息和更新通知。',
  },
  {
    q: '51黑料网页版有哪些核心功能？',
    a: '51黑料网页版提供完整的浏览体验，核心功能包括：实时快讯时间线（跟踪最新热点）、焦点专题深度解读（多角度还原事件）、热门话题标签系统（快速定位兴趣领域）、吃瓜排行榜（热度排序）、图文爆料卡片（精选优质内容）、主题索引导航（按类别浏览）等。所有功能均免费使用。',
  },
  {
    q: '如何向51黑料投稿或爆料？',
    a: '51黑料欢迎优质内容创作者和热心网友投稿爆料。你可以通过51黑料网站首页的"联系我们"板块获取投稿邮箱和官方社交媒体联系方式。提交内容时请确保信息真实可靠，我们的编辑团队会在收到投稿后尽快审核。对于独家优质内容，我们会给予优先展示和推荐位支持。',
  },
];

const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20red%20abstract%20editorial%20video%20thumbnail%20style%20composition%20with%20soft%20gradients%20and%20geometric%20shapes%2C%20modern%20YouTube-style%20design%2C%20clean%20warm%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-01-51hl&orientation=landscape',
    title: '娱乐圈年度十大名场面盘点，每一条都值得回看',
    duration: '15:28',
    views: '128万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20golden%20amber%20abstract%20editorial%20video%20thumbnail%20style%20with%20soft%20flowing%20gradients%2C%20modern%20media%20player%20aesthetic%2C%20clean%20warm%20design%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-02-51hl&orientation=landscape',
    title: '独家对话：热门综艺导演讲述台前幕后的故事',
    duration: '22:41',
    views: '96万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20coral%20and%20cream%20abstract%20editorial%20video%20thumbnail%20composition%20with%20soft%20gradients%20and%20organic%20shapes%2C%20modern%20streaming%20platform%20aesthetic%2C%20sophisticated%20warm%20design%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-03-51hl&orientation=landscape',
    title: '音乐节现场直击：多角度还原最燃舞台瞬间',
    duration: '18:05',
    views: '85万',
  },
];

const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '7×24小时全天候更新，第一时间推送最新娱乐资讯和热点话题，确保你永不落伍。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '精选内容',
    desc: '专业编辑团队结合智能算法，从海量信息中筛选高质量内容，拒绝低质和虚假信息。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '51黑料网页版完美适配桌面端和移动端，无需下载App，浏览器打开即享完整体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '严格的内容审核机制和隐私保护策略，为用户打造安全、放心的浏览环境。',
  },
  {
    icon: 'ri-group-line',
    title: '社区互动',
    desc: '活跃的读者社区氛围，热门评论、话题讨论、观点碰撞，吃瓜不再是一个人的事。',
  },
];

export default function SectionGroupD() {
  return (
    <>
      <section id="faq" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
            <span className="text-xs text-foreground-400 ml-2">快速了解</span>
          </div>
          <div className="max-w-3xl mx-auto space-y-4">
            {faqItems.map((item, i) => (
              <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden" open>
                <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 pr-4">{item.q}</h3>
                  <div className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 group-open:text-primary-500 transition-colors">
                    <i className="ri-arrow-down-s-line text-sm transition-transform group-open:rotate-180"></i>
                  </div>
                </summary>
                <div className="px-5 pb-5">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section id="app" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">客户端下载</h2>
            <span className="text-xs text-foreground-400 ml-2">随时吃瓜</span>
          </div>
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 max-w-4xl mx-auto">
              <div className="flex-shrink-0">
                <div className="w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center">
                  <span className="text-4xl md:text-5xl font-heading font-black text-white">51</span>
                </div>
              </div>
              <div className="flex-1 text-center lg:text-left">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">51黑料网页版 · 随时随地吃瓜</h3>
                <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                  无需下载安装，打开浏览器访问51黑料官网地址即可畅享完整功能。支持桌面端与移动端自适应浏览，你也可以将51黑料网站首页添加到手机主屏幕，获得接近原生App的使用体验。51黑料网页版登录直达，简单快捷。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-global-line text-base w-4 h-4 flex items-center justify-center"></i>
                    访问网页版
                  </a>
                  <a
                    href="#hero"
                    className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-bookmark-line text-base w-4 h-4 flex items-center justify-center"></i>
                    添加到书签
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="media" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">视频专区</h2>
            <span className="text-xs text-foreground-400 ml-2">精选视频</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item, i) => (
              <div key={i} className="group cursor-pointer">
                <div className="relative aspect-video rounded-xl overflow-hidden mb-4 bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/60 text-white text-[10px] font-medium">
                    {item.duration}
                  </div>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="features" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
            <span className="text-xs text-foreground-400 ml-2">为什么选择51黑料</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {features.map((item, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 text-center group hover:border-primary-200 hover:bg-background-50 transition-colors cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-xl text-primary-500 w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}